"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("../sharepoint/index"));



//////////////////
// WEBPACK FOOTER
// ./lib/exports/sp.js
// module id = 75
// module chunks = 0